// Fallback category list used by AdminBusinesses when the admin endpoint
// doesn't surface a custom category override. Kept here (not in the
// canonical backend/services/categories.json) because this file was
// historically shared with the legacy service_regions + based_states
// lists, which were dropped 2026-04-17 when the UN-5 + ISO 3166-2
// cascading picker replaced them.

export const DEFAULT_CATEGORIES = [
  'Accounting & Tax', 'Bitcoin Education', 'Bitcoin Infrastructure', 'Bitcoin Service',
  'Cleaning Services', 'Construction / Trades', 'Counselling & Health Services',
  'Electrical / Engineering', 'Graphic & Creative Services', 'Health & Wellness',
  'Hospitality & Catering', 'Information Technology / Development', 'Internet & Communications',
  'Manufacturing / Industrial', 'Retail / Online Stores', 'Training & Coaching',
  'Travel & Accommodation', 'Other'
];
